import config from '../../../config'
import http from './http-util'

class ApplyRetailCreditServiceApi {
  static fetchLinksByStoreId(storeId, token) {
    return http.get(
      token,
      `${config.applyRetailCreditServiceUrl}/urls/stores/${storeId}`,
    )
  }
}

export default ApplyRetailCreditServiceApi
